<template>
    <div class="head_body">
        <div class="head_title">
            <div class="car_no">客户卡号</div>
            <div class="car_no_number">{{ recordLoginText }}</div>
        </div>
        <div class="b_text">选择流量包</div>
        <div class="c_flex">
            <div class="c_flex_item" v-for="(item,i) in dataList" :key="item.id" @click="itemChange(item,i)">
                <div class="c_flex_left" :class="{'left_active' : index === i}"> 
                    <div class="left_title"> {{ item.packageName  ? item.packageName : item.name }} </div>
                    <div class="left_time">
                        <template v-if="item.type === 17"> 有效期：30天有效期 套餐顺延生效，当月如需继续使用 请充值加油包。</template>
                        <template v-if="item.type === 10"> 有效期：每个月月底清零，套餐包用完可继续购买加油包使用。</template>
                        <template v-if="item.type === 18"> 有效期：主套餐用完后，请购买此套餐</template>
                        <template v-if="item.type === 2">  有效期：每个月月底清零，套餐可无限叠加购买使用</template>
                        <template v-if="item.type === 20 || item.type === 21"> 有效期：一年有效期，每个月可用100G</template>
                    </div>
                </div>
                <div class="c_flex_right">
                    <div class="right_price">{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}<span>元</span></div>
                    <div class="right_y">套餐原价</div>
                </div>
            </div>
        </div>
        <div class="b_text">选择订购方式</div>

        <div class="d-flex">
            <div class="d-flex-left" :class="{'d-flex-left_active': sx === 0}" @click="paymentChange(0)">
                <div class="f_title">预存订购</div>
                <div class="f_price">{{yPrice}}<span>元</span></div>
            </div>
            <div class="d-flex-left" style="margin-left:10px;" :class="{'d-flex-left_active': sx === 1}" @click="paymentChange(1)">
                <div class="f_title">微信订购</div>
                <div class="f_price">{{wPrice}}<span>元</span></div>
            </div>
        </div>
        <div class="srz" v-show="sx === 0">原价29元 ，现预存100送120元赠送金（仅此开户页面赠送），每月可抵扣10元赠送金   仅需19元就能享受100g ，预存可用来购买套餐</div>
        <div class="srz" v-show="sx === 1">每个月29元/100G，当月使用完 可购买加油包</div>
        <div class="bottom-fex">
            <div class="b_radio">
                <van-radio-group v-model="radio" direction="horizontal">
                    <van-radio name="0" checked-color="#F99F0E">本月生效</van-radio>
                    <van-radio name="1" checked-color="#F99F0E">次月生效</van-radio>
                </van-radio-group>
            </div>
            <div class="htne">请在有效时间内使用，月底清零</div>
            <div class="b_flex">
                <div class="pcire"><span style="color:#314D87;font-size:14px;">金额：</span>{{sx === 0 ? 100:wPrice}}<span>元</span></div>
                <div class="b-button">
                    <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">订 购</van-button>
                </div>
            </div>
        </div>


        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
    <div class="van-popup van-popup--round van-popup--center changePasswordPanel-cardSetUp"  style="z-index: 2000; min-height: 25%; min-width: 80%;"  v-show="showPasswordPanel" :style="{top:passwordPanelTop+'%'}" >
      <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>
      <!-- 密码输入框 -->
      <p>设置开户支付密码：</p>
      <van-password-input
          :value="password"
          :focused="passwordKeyboard"
          @focus="passwordOnfocus()"
      />
      <!-- 再次确认密码输入框 -->
      <p>再次确认开户密码：</p>
      <van-password-input
          :value="confirmPassword"
          :focused="confirmPasswordKeyboard"
          @focus="confirmPasswordOnfocus()"
      />
      <div class="confirmChangePassword">
        <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge1()">确 定 </van-button>
      </div>
    </div>
    <!-- 数字键盘 -->
    <van-number-keyboard
        :z-index="2015"
        :show="passwordKeyboard"
        @input="passwordOnInput"
        @delete="passwordOnDelete"
        @blur="passwordKeyboard = false"
    />
    <van-number-keyboard
        :z-index="2015"
        :show="confirmPasswordKeyboard"
        @input="confirmPasswordOnInput"
        @delete="confirmPasswordOnDelete"
        @blur="confirmPasswordKeyboard = false"
    />
    </div>
</template>
<script>
import {Toast,Dialog} from 'vant';
import {wxRequest} from '@/api/user.js'
export default {
    data(){
        return{
            radio:'0',
            index:0,
            wPrice:0,
            yPrice:0,
            isAdmin:'',
            recordLoginText: localStorage.getItem('recordLoginText'),
            indexActive:'',
            sx:0,
            dataList:[],
            //设置密码
            password: '',
            iccid:'',
            confirmPassword: "",
            alreadySetUp: false,
            showPasswordPanel: false,
            passwordKeyboard: false,
            confirmPasswordKeyboard: false,
            passwordPanelTop: 50,
            isWx:false,
        }
    },
    created(){
        this.iccid = this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid');
        //判断是不是在微信环境中
        var ua = window.navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.isWx = true;
        }
        this.init()
    },
    methods:{
        init(){
            wxRequest("sim/user/soldPkg/my", {iccid:this.iccid}, "get").then(res => {
                if (res.data.code === '200') {
                    this.isAdmin = res.data.data.isAdmin
                    this.dataList = res.data.data.list
                    if(res.data.data.list.length > 0){
                        this.indexActive = res.data.data.list[0].id
                        this.wPrice = (res.data.data.list[0].salePriceRmb ? res.data.data.list[0].salePriceRmb : res.data.data.list[0].salePrice / 100 ).toFixed(2)
                        this.yPrice = ((res.data.data.list[0].salePriceRmb ? res.data.data.list[0].salePriceRmb : res.data.data.list[0].salePrice / 100 )- 10).toFixed(2)
                    }
                } else {
                    Toast.fail(res.data.message);
                }
            })
        },
        paymentChange(i){
            this.sx = i
        },
        itemChange(data,i){
            this.index = i
            this.indexActive = data.id
            this.wPrice = (data.salePriceRmb ? data.salePriceRmb : data.salePrice / 100).toFixed(2)
            this.yPrice = ((data.salePriceRmb ? data.salePriceRmb : data.salePrice / 100)- 10).toFixed(2)
        },
        //订购
        sureToRecharge(){
            if (this.indexActive == '') {
                Dialog.alert({message: "请选择购买套餐"});
                return false;
            }
            if(this.sx === 1){//微信支付
                var params = {         
                    iccid:  this.iccid,
                    isAdmin: this.isAdmin,// 上面套餐信息接口 请求返回的参数          
                    soldPackageId: this.indexActive,//套餐ID        
                    isNextMonth: this.radio, // 0 本月   1 次月        
                    payType: 20, //固定20  表示微信支付         
                }
                  let formData = new FormData();
                Object.keys(params).forEach((key) => {
                    formData.append(key, params[key]);
                });
                wxRequest("order/pkgOrder/add", formData, "post").then(res => {
                    if (res.data.code == 200) {
                        if (params.payType == 50) {//乐刷
                            window.location.href = res.data.data.jspay_url;
                        } else if (params.payType == 20) {//微信第三方
                            if (this.isWx) {
                                var param = res.data.data.param;
                                if (typeof WeixinJSBridge == "undefined") {
                                    if (document.addEventListener) {
                                        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                                    } else if (document.attachEvent) {
                                        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                                    }
                                } else {
                                    this.onBridgeReady(param);
                                }
                            } else {
                                window.location.href = res.data.data.mweb_url;
                            }
                        } else if (type == 60) { //汇付天下
                            let datas = JSON.parse(res.data.data);
                            if (datas.status === 'succeeded') {
                                let payment = datas;
                                AdaPay.doPay(payment, (res) => {
                                    Dialog.alert({title: '提示', message: res.result_message});
                                })
                            }
                        }
                    } else {
                        Dialog.alert({message: res.data.message});
                    }
                })
            }else{
                this.showPasswordPanel = true;
            }
        },
        //微信支付
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke( 'getBrandWCPayRequest', param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    _this.$router.push({ path: '/user/payBack', query: { iccid: _this.$store.state.iccid  }})
                }
            })
        },
        //预存支付
        sureToRecharge1(){
            var params = {         
                iccid:this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid'), 
                amount: 100 * 100, //固定值         
                giftBalance: 0, //固定值 	   
                yucun: 1, //固定值
                payPass: this.confirmPassword, //用户的支付密码         
                isAdmin: this.isAdmin, //套餐详细接口返回的参数         
                soldPackageId: this.indexActive, //套餐ID         
                isNextMonth: this.radio, // 0 本月   1 次月         
                payType: 20,// 固定微信支付         
                pkgId:this.indexActive, //套餐ID  ,            
            }
            wxRequest("order/user/create/investOrder", params, "post").then(res => {
                if (res.data.code == 200) {
                    if (params.payType == 50) {//乐刷
                        window.location.href = res.data.data.jspay_url;
                    } else if (params.payType == 20) {//微信第三方
                        if (this.isWx) {
                            var param = res.data.data.param;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                        } else {
                            window.location.href = res.data.data.mweb_url;
                        }
                    } else if (params == 60) { //汇付天下
                        let datas = JSON.parse(res.data.data);
                        if (datas.status === 'succeeded') {
                            let payment = datas;
                            AdaPay.doPay(payment, (res) => {
                                Dialog.alert({title: '提示', message: res.result_message});
                            })
                        }
                    }
                } else {
                    Dialog.alert({message: res.data.message});
                }
            })
        },
        /***   修改密码     ***/
        passwordOnfocus() {
            this.passwordKeyboard = true;
            this.confirmPasswordKeyboard = false;
            this.passwordPanelTop = 30;
        },
        passwordOnDelete() {
            this.password = this.password.slice(0, this.password.length - 1);
        },

        passwordOnInput(key) {
            this.password = (this.password + key).slice(0, 6);
        },


        confirmPasswordOnfocus() {
            this.passwordKeyboard = false;
            this.confirmPasswordKeyboard = true;
            this.passwordPanelTop = 30;
        },
        confirmPasswordOnDelete() {
            this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
        },

        confirmPasswordOnInput(key) {
            this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
        },


        cancelChangePassword() {
            this.password = '';
            this.confirmPassword = '';
            this.passwordPanelTop = 50;
            this.showPasswordPanel = false;
        },

        checkPassword() {
            if (this.password.length < 6) {
                Dialog.alert({message: "请设置六位支付密码"});
                return false;
            }

            if (this.password != this.confirmPassword) {
                Dialog.alert({message: "两次输入的新密码不一致"});
                return false;
            }
            return true;
        },


        /***   修改密码  end   ***/
    }
}
</script>

<style lang="less" scoped>
    .head_body{
        padding:0 13px;
        padding-bottom:130px;
        .head_title{
            margin-top:20px;
            background: url('../../assets/dzp/t_bg.png') no-repeat center;
            background-size: 100% 100%;
            height:78px;
            .car_no{
                color: #8495D1;
                font-size: 12px;
                padding-top:18px;
                padding-left: 18px;
            }
            .car_no_number{
                padding-left: 18px;
                padding-top:14px;
                color: #fff;
                font-size:18px;
                font-family: HarmonyOS_Sans_SC_Bold;
            }
        }
        .b_text{
            color: #314D87;
            font-size:18px;
            margin-top:30px;
            font-weight:bold;
        }
        .c_flex{
            margin-top:12px;
            .c_flex_item{
                display: flex;
                margin-bottom: 10px;
                .c_flex_left{
                    width:80%;
                    background: #F7F8FA;
                    border:1px solid #F7F8FA;
                    border-top-left-radius: 8px;
                    border-bottom-left-radius: 8px;
                    .left_title{
                        color:#314D87;
                        font-size: 18px;
                        margin-top: 14px;
                        margin-left: 18px;
                        margin-bottom: 8px;
                        font-weight: 600;
                    }
                    .left_time{
                        font-size:10px;
                        color: #8795B6;
                        margin-left:18px;
                        margin-right: 40px;
                        margin-bottom:16px;
                        line-height:20px;
                    }
                }
                .left_active{
                    border:1px solid #F99F0E;
                    background: #FFF7EB;
                }
                .c_flex_right{
                    width:20%;
                    background: #F99F0E;
                    border:1px solid #F99F0E;
                    border-top-right-radius: 8px;
                    border-bottom-right-radius: 8px;
                    color:#fff;
                    text-align: center;
                    .right_price{
                        font-size: 24px;
                        margin-top:20px;
                        span{
                            font-size: 10px;
                            padding-left:6px;
                        }
                    }
                    .right_y{
                        width:40px;
                        height:20px;
                        background: url(../../assets/dzp/t_bg_small.png)no-repeat center;
                        background-size:100% 100%;
                        color:#F99F0E;
                        text-align: center;
                        line-height:22px;
                        font-size: 10px;
                        margin: auto;
                    }
                }
            }
        }
        .d-flex{
            display: flex;
            margin-top:12px;
            margin-bottom:10px;
            .d-flex-left{
                width:48%;
                height:72px;
                text-align: center;
                background: #F7F8FA;
                border-radius: 8px;
                border:1px solid #F7F8FA;
                .f_title{
                    color: #314D87;
                    font-size: 18px;
                    font-weight: 600;
                    margin-top: 12px;
                }
                .f_price{
                    font-size:24px;
                    color: #314D87;
                    margin-top:10px;
                    span{
                        font-size:10px;
                    }
                }
            }
            .d-flex-left_active{
                background:#FFF7EB;
                border:1px solid #F99F0E;
                .f_title{
                    color: #F99F0E;
                }
                .f_price{
                    color: #F99F0E;
                }
            }
        }
        .srz{
            background: #FFF7EB;
            padding:8px 14px;
            font-size: 16px;
            color: #0a2ba4; //  #F99F0E
            line-height:20px;
            border-radius:8px;
        }
        .bottom-fex{
            position: fixed;
            width:100%;
            bottom:0;
            left:0;
            right:0;
            padding-top:12px;
            background:#fff;;
            .b_radio{
                margin-bottom: 15px;
                margin-left:14px;
            }
            .htne{
                color:#fff;
                font-size: 10px;
                background: #ED0608;
                line-height: 20px;
                padding-left:14px;
            }
            .b_flex{
                display: flex;
                margin-top:8px;
                .pcire{
                    width:50%;
                    padding-left:14px;
                    font-size:24px;
                    color: #F99F0E;
                    margin-top:10px;
                    span{
                        font-size:10px;
                    }
                }
                .b-button{
                    width:50%;
                    text-align: center;
                    margin-bottom:10px;
                    .confirmChangePasswordBtn{
                        color: #fff;
                        width:80%;
                        margin: auto;
                        background:#F99F0E;
                        border-radius:22px;
                        border:none;
                        font-size:18px;
                    }
                }
            }
        }
    }
    .changePasswordPanel-cardSetUp{
	  padding: 10px;

	  .icon-cross{
	  	position: absolute; 
	  	right: 10px;
	  	font-size: 16px;
	  }

	  p{
	    margin: 10px 16px 0 16px;
	    line-height: 30px;
	  }

	  .confirmChangePassword{
	    display:flex;
	    justify-content: flex-end;
	    margin-top: 20px;

	    .confirmChangePasswordBtn{
	    	width: 80px;
	      	margin: 0 15px;
	    }
	  }


	}
</style>